import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, StockImageDisplayItem, WebsiteMediaLibraryDisplayItem, WebsiteMediaLibraryInputItem, WebsiteMediaLibraryItemSearchOptions, WebsiteMediaLibraryUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace WebsiteMediaLibraryRoutes {
    export namespace StockImages {
        export const Get = ApiRoute.Define({
            URL: `websitestockimages`,
            Kind: RequestKind.Get,
            ResultType: Array<StockImageDisplayItem>,
        });
    }

    export namespace Items{
        export const Search = ApiRoute.Define({
            URL: `search/websitemedialibrary`,
            Kind: RequestKind.Post,
            BodyType: WebsiteMediaLibraryItemSearchOptions,
            ResultType: DisplayItemCollection<WebsiteMediaLibraryDisplayItem>,
            PagingAllowed: true
        });

        export const Get = ApiRoute.Define({
            URL: (websiteMediaLibraryItemID: string) => `websitemedialibrary/${websiteMediaLibraryItemID}`,
            Kind: RequestKind.Get,
            ResultType: WebsiteMediaLibraryDisplayItem
        });

        export const Add = ApiRoute.Define({
            URL: `websitemedialibrary`,
            Kind: RequestKind.Post,
            BodyType: FormData,
            ResultType: string
        });

        export const Update = ApiRoute.Define({
            URL: (websiteMediaLibraryItemID: string) => `websitemedialibrary/${websiteMediaLibraryItemID}`,
            Kind: RequestKind.Put,
            BodyType: WebsiteMediaLibraryUpdateItem,
            ResultType: boolean
        });

        export const Delete = ApiRoute.Define({
            URL: (websiteMediaLibraryItemID: string) => `websitemedialibrary/${websiteMediaLibraryItemID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }

}
